var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSouthCarolinaReversed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon south carolina") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#F3F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.022,31.827,45,23.209a.225.225,0,0,0-.168-.044l-8.315,1.25a.12.12,0,0,1-.076-.01l-4.956-2.665a.184.184,0,0,0-.123-.026l-10.841.941a.213.213,0,0,0-.079.022l-5.21,2.581a.221.221,0,0,0-.1.1L13.918,27.7a.22.22,0,0,0,.038.255L31.593,45.89l.018.021,2.707,3.835,1.819,2.24a.219.219,0,0,0,.171.082l.034,0,4.141-.659a.22.22,0,0,0,.093-.4l-2.155-1.53a.128.128,0,0,1-.055-.13.132.132,0,0,1,.1-.106l3.158-.9a.149.149,0,0,1,.087,0l.844.364a.225.225,0,0,0,.235-.039l4.929-4.5a.218.218,0,0,0,.068-.126L48.293,41a.124.124,0,0,1,.079-.1.131.131,0,0,1,.13.019l1.415,1.105a.217.217,0,0,0,.176.043.223.223,0,0,0,.148-.1l1.867-3.13a.213.213,0,0,0,.028-.079l.361-2.327a.214.214,0,0,1,.036-.08l3.52-4.207a.219.219,0,0,0,.051-.164A.225.225,0,0,0,56.022,31.827Z",
    fill: "#00789E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthCarolinaReversed);
export default __webpack_public_path__ + "static/media/south-carolina-reversed.b6ad09063ce234b80047baaf9ac02001.svg";
export { ForwardRef as ReactComponent };